'use client';

import { Header } from '@/components/header';
import NotFoundImage from '@/components/icons/NotFound';
import { Button } from '@/components/ui/button';
import { useParams, useRouter } from 'next/navigation';
import { useTranslation } from '../i18n/client';

export default function NotFound() {
  const { lng } = useParams() as { lng: string };
  const router = useRouter();
  const { t } = useTranslation(lng, 'not-found');

  const goToHome = () => {
    router.push('/');
  };

  return (
    <div className='h-screen w-full overflow-hidden bg-black'>
      <Header dark showStepper={false} />
      <main className='flex w-full flex-col items-center justify-center gap-10 px-4 pb-6 pt-26 lg:flex-row lg:gap-20 lg:px-12 lg:pb-20 lg:pt-40'>
        <div className='md:h-[537px]'>
          <NotFoundImage width={300} />
        </div>
        <div className='flex flex-col text-center lg:text-left'>
          <p className='mb-3 text-3xl font-bold text-slate-50 lg:text-6xl lg:font-extrabold'>{t('title')}</p>
          <p className='mb-10 text-slate-50 lg:mb-7'>{t('subtitle')}</p>
          <Button className='w-full lg:w-fit' variant='white' onClick={goToHome}>
            {t('button')}
          </Button>
        </div>
      </main>
    </div>
  );
}
